(function(w, d) {
    function domReadyFunctions() {
       let shareBtns = d.querySelectorAll('.btn-share');
        shareBtns.forEach((e) =>{
            e.addEventListener('blox-button-click',()=>{
                let shareList= e.parentElement.querySelector('.popover');
                if (shareList.classList.contains('d-none')){
                    shareList.classList.remove('d-none');
                } else {
                    shareList.classList.add('d-none');
                } 
            });
        });
        
        d.addEventListener('click',(e)=>{
            if (event.target.closest('.btn-share') || event.target.closest('.popover')) return;
            d.querySelectorAll('.popover:not(.d-none)').forEach(p => p.classList.add('d-none'));
        });
        
        
        /* Save button functionality */
        d.querySelector('.save-asset')?.addEventListener('click',(e)=>{
            const offset = 80;
            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
            let submitForm = d.querySelector('.save-list-'+ e.target.dataset.assetUuid +'-form');
            if (submitForm) {
                HTMLFormElement.prototype.submit.call(submitForm);
            }
        });
        
        /* copy Icon functionality*/
        function enableCopyUrlOnBloxIcon() {
            d.addEventListener('click', function (event) {
                const icon = event.target.closest('blox-icon[icon="copy"]');
                if (!icon) return;
                const url = window.location.href;
            

                if (navigator.clipboard && window.isSecureContext) {
                    navigator.clipboard.writeText(url)
                        .then(() => {
                        })
                       .catch(err => {
                          console.error('Clipboard copy failed:', err);
                       });
                } else {
                    const textarea = d.createElement('textarea');
                    textarea.value = url;
                    textarea.style.position = 'fixed';
                    textarea.style.opacity = '0';
              
                    d.body.appendChild(textarea);
                    textarea.focus();
                    textarea.select();
              
                    try {
                      d.execCommand('copy');
                    } catch (err) {
                      console.error('Fallback copy failed:', err);
                    }
              
                    d.body.removeChild(textarea);
                }
            });
        }
        enableCopyUrlOnBloxIcon()
    }

  if (d.readyState == 'loading') {
        d.addEventListener('DOMContentLoaded', function() {
            domReadyFunctions();
        });
    } else {
        domReadyFunctions();
    }
})(window, document);